<template>
  <div class="md:h-screen flex flex-col md:flex-row">
    <div
      class="bg-yellow-500 h-20 md:h-screen flex flex-col justify-center w-full md:w-1/2"
    >
      <h3 class="font-bold text-4xl left-header">Projects</h3>
      <navigation :primary="'dark'" class="md:mt-64" />
    </div>
    <div class="w-full md:w-1/2 p-2 grid grid-cols-1 xl:grid-cols-2">
      <div
        class="experience shadow-lg h-74 w-5/6 flex justify-center items-center cursor-pointer"
        v-for="(project, index) in projects"
        @click="showProject(project)"
        :key="index"
      >
        <project-tile :project="project" />
      </div>
    </div>
    <modal v-if="selectedProject" :showing="showing" @close="showing = false">
      <project-tile
        :project="selectedProject"
        :hide-read-more="true"
        :view-all="true"
      />
    </modal>
  </div>
</template>
<script>
import Navigation from "./Navigation";
import Modal from "./widget/Modal";

import ProjectTile from "./widget/ProjectTile";
export default {
  components: {
    Navigation,
    ProjectTile,
    Modal,
  },
  data: () => {
    return {
      showing: false,
      selectedProject: null,
      projects: [
        {
          name: "Amazon Price Tracker - Ztracker",
          desc: "A React Native app, used to track prizes for amazon products.",
          brief:
            "Built a react native app, and a backend supported by node js with express framework along with puppetter for webscrapping and firebase for datastorage and user notifications",
          logo: "amazon/logo.png",
          img_size: "sm",
          logo_size: "",
          images: [
            "amazon/1.jpeg",
            "amazon/2.jpeg",
            "amazon/3.jpeg",
            "amazon/4.jpeg",
          ],
        },
        {
          name: "Bike Rentals - Goa Bike Rentals",
          desc:
            "Platform build with laravel and vue, for dealers to rent their bikes,",
          logo: "gbr/logo.png",
          img_size: "lg",
          logo_size: "",
          images: [
            "gbr/1.png",
            "gbr/2.png",
            "gbr/3.png",
            "gbr/4.png",
            "gbr/5.png",
            "gbr/6.png",
            "gbr/7.png",
            "gbr/8.png",
          ],
        },
        {
          name: "Blood Cancer predicition",
          desc:
            "System developed in java aimed at predicting leukemia using image processing and machine learning.",
          logo: "bcp/no_logo.png",
          images: [],
          logo_size: "",
          brief: "Here's a link to the journal",
          link:
            "http://www.tjprc.org/publishpapers/2-14-1530526922-1.IJCSEITRAUG20181.pdf",
        },
        {
          name: "Milton Keyens Marathon  2020",
          desc:
            "Progressive web app build with vue JS, to get latest informations about the marathon to the runners",
          brief: "<b>Project built at Xncreations</b>",
          logo: "mk/logo.png",
          link: "https://mkmarathon.app/",
        },
      ],
    };
  },
  watch: {
    showing() {
      if (this.showing) {
        document.documentElement.style.overflow = "hidden";
      } else {
        document.documentElement.style.overflow = "auto";
      }
    },
  },
  methods: {
    showProject(project) {
      console.log(project);
      this.selectedProject = project;
      this.showing = true;
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Piedra&display=swap");
.left-header {
  font-family: "Piedra", cursive;
  letter-spacing: 5px;
  word-spacing: 10px;
}

.experience {
  align-self: center;
  justify-self: center;
  padding: 1em;
}
</style>
